import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import TeacherRegister from "@/pages/TeacherRegister";
import CodesPage from "@/pages/teacher/CodesPage";
import Home from "@/pages/Home";
import TeacherLogin from "@/pages/TeacherLogin";
import PanelLayout from "@/components/teacher/PanelLayout";
import PoolsPage from "@/pages/teacher/PoolsPage";
import PoolDetailPage from "@/pages/teacher/PoolDetailPage";
import GamesPage from "@/pages/teacher/GamesPage";
import ActivitiesPage from "@/pages/teacher/ActivitiesPage";
import AnalyticsPage from "@/pages/teacher/AnalyticsPage";
import RecordsPage from "@/pages/teacher/RecordsPage";
import LogsPage from "@/pages/teacher/LogsPage";
import ReviewsPage from "@/pages/teacher/ReviewsPage";
import PlaylistsPage from "@/pages/teacher/PlaylistsPage";
import PreviewPage, { PreviewStudent } from "@/pages/teacher/PreviewPage";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import LiveGamePage from "@/pages/teacher/LiveGamePage";
import JoinPage from "@/pages/JoinPage";
import StudentGame from "@/pages/StudentGame";
import BoardPage from "@/pages/BoardPage";
import { DevAccessPage, MaintenanceGate } from "@/components/teacher/SiteAdmin";
import { CookieBanner, LegalPage, SiteFooter } from "@/components/Legal";

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <MaintenanceGate>
      <BrowserRouter>
        <Routes>
          <Route path="/gelistirici/:key" element={<DevAccessPage />} />
          <Route path="/kvkk" element={<LegalPage kind="kvkk" />} />
          <Route path="/kullanim-kosullari" element={<LegalPage kind="terms" />} />
          <Route path="/gizlilik-politikasi" element={<LegalPage kind="privacy" />} />
          <Route path="/akademik-durustluk" element={<LegalPage kind="ethics" />} />
          <Route path="/" element={<Home />} />
          <Route path="/ogretmen/giris" element={<TeacherLogin />} />
          <Route path="/ogretmen/kayit" element={<TeacherRegister />} />
          <Route path="/katil/:code" element={<JoinPage />} />
          <Route path="/oyun/:code" element={<StudentGame />} />
          <Route path="/tahta/:code" element={<ProtectedRoute><BoardPage /></ProtectedRoute>} />
          <Route path="/onizleme/:code" element={<ProtectedRoute><PreviewPage /></ProtectedRoute>} />
          <Route path="/onizleme-ogrenci/:code" element={<PreviewStudent />} />
          <Route path="/ogretmen" element={<ProtectedRoute><PanelLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="havuzlar" replace />} />
            <Route path="havuzlar" element={<PoolsPage />} />
            <Route path="havuzlar/:poolId" element={<PoolDetailPage />} />
            <Route path="oyunlar" element={<GamesPage />} />
            <Route path="etkinlikler" element={<ActivitiesPage />} />
            <Route path="analiz" element={<AnalyticsPage />} />
            <Route path="rekorlar" element={<RecordsPage />} />
            <Route path="loglar" element={<LogsPage />} />
            <Route path="onaylar" element={<ReviewsPage />} />
            <Route path="listeler" element={<PlaylistsPage />} />
            <Route path="kodlar" element={<CodesPage />} />
            <Route path="oyun/:code" element={<LiveGamePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <SiteFooter />
        <CookieBanner />
      </BrowserRouter>
      </MaintenanceGate>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
